function init() {

	var mainNav = document.getElementById("main-nav"),
		mainMenuToggler = document.getElementById("primary-nav-toggler"),
		htmlTag = document.getElementsByTagName("html")[0];

	if(mainMenuToggler){
		mainMenuToggler.addEventListener("click", () => {

			let isOpen = mainNav.classList.contains("open");
			if (isOpen) {
				mainMenuToggler.setAttribute("aria-expanded", "false");
				mainNav.classList.remove("open");
				htmlTag.classList.remove("no-scroll");
			} else {
				mainMenuToggler.setAttribute("aria-expanded", "true");
				mainNav.classList.add("open");
				htmlTag.classList.add("no-scroll");
			}
		});
	}
	
}

export default { init };
